import { useEffect } from 'react';

const useTrackAppError = () => {
    useEffect(() => {
        const controller = new AbortController();
        const trackAppError = (event) => {
            console.log({APPError: event});
            // console.log({APPError: source});
            // console.log({APPError: lineno});
            // console.log({APPError: colno});
            // console.log({APPError: error});
        };

        const trackUnhandledError = (event) => {
            console.log({UnhandledError: event});
            // console.log({UnhandledError: source});
            // console.log({UnhandledError: lineno});
            // console.log({UnhandledError: colno});
            // console.log({UnhandledError: error});
        };


        window.addEventListener('error', trackAppError, { signal: controller.signal });
        window.addEventListener('unhandledrejection', trackUnhandledError, { signal: controller.signal });

        return () => {
            controller.abort();
        };
    }, []);
};

export default useTrackAppError;